import { useTheme } from '@emotion/react';
import { Box } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

import t2w from '../../../assets/t2w.png';
import pass from '../../../assets/pass.png';
import todo from '../../../assets/todo.png';
import useTitle from '@/hooks/useTitle';
import ProductPresentation from '@/components/product/ProductPresentation';

const products = [
  {
    slug: 'pass',
    title: 'Passwort-Tool',
    heading: 'Übertragen Sie Passwörter schnell und sicher mit unserem ',
    description:
      'Verschicken Sie Passwörter sicher und einfach. Unser Tool verschlüsselt Ihre Passwörter noch auf Ihrem Gerät und erzeugt einen Einmallink für den Abruf.',
    image: pass,
    priceBreakdown: [
      {
        currency: 'eur',
        description: 'Einrichtung',
        interval: 'one_time',
        label: 'Todo-Tool',
        quantity: 1,
        subtotal: 0,
      },
      {
        currency: 'eur',
        description: 'Preis Pro Deployment',
        interval: 'month',
        label: 'Todo-Tool',
        quantity: 1,
        subtotal: 2999,
      },
    ],
  },
  {
    slug: 'todo',
    title: 'Todo-Tool',
    heading: 'Erfassen Sie Aufgaben schnell und einfach mit unserem ',
    description: `Unser Todo-Tool bietet Ihnen eine minimalistische Oberfläche, um neue Tickets schnell und einfach zu erfassen. So können Sie direkt im Gespräch mit Ihren Kunden wichtige Dinge festhalten.`,
    image: todo,
    priceBreakdown: [
      {
        currency: 'eur',
        description: 'Einrichtung',
        interval: 'one_time',
        label: 'Todo-Tool',
        quantity: 1,
        subtotal: 0,
      },
      {
        currency: 'eur',
        description: 'Preis Pro Deployment',
        interval: 'month',
        label: 'Todo-Tool',
        quantity: 1,
        subtotal: 2999,
      },
    ],
  },
  {
    slug: 't2w',
    title: 'Tanss2weclapp',
    heading:
      'Automatisieren Sie Ihre Abrechnung mit unserer TANSS2weclapp Schnittstelle ',
    description: `Unsere Schnittstelle bietet Ihnen die Möglichkeit, weclapp Aufträge
            und Rechnungen aus TANSS-Belegen zu erzeugen. Außerdem können Sie
            bequem Stammdaten zwischen den Systemen übertragen.`,
    image: t2w,
    priceBreakdown: [
      {
        currency: 'eur',
        description: 'Einrichtung',
        interval: 'one_time',
        label: 'Todo-Tool',
        quantity: 1,
        subtotal: 39900,
      },
      {
        currency: 'eur',
        description: 'Preis Pro Deployment',
        interval: 'month',
        label: 'Todo-Tool',
        quantity: 1,
        subtotal: 9900,
      },
    ],
  },
];

const apps = [
  {
    name: 'pass',
    title: 'Passwort-Tool',
    description:
      'Verschicken Sie Passwörter sicher und einfach. Unser Tool verschlüsselt Ihre Passwörter noch auf Ihrem Gerät und erzeugt einen Einmallink für den Abruf.',
    image: pass,
  },
  {
    name: 'todo',
    title: 'Todo-Tool',
    description:
      'Erzeugen Sie TANSS-Tickets und weclapp-Chancen aus einer minimalistischen Oberfläche heraus.',
    image: todo,
  },
  {
    name: 't2w',
    title: 'Tanss2weclapp',
    description:
      'Verbinden Sie Tanss und weclapp um Rechnungen aus TANSS heraus zu erzeugen und Stammdaten zu synchronisieren.',
    image: t2w,
  },
];

export default function Product() {
  const { name } = useParams();
  const product = products.find((product) => product.slug === name);
  const app = apps.find((app) => app.name === name);
  const theme = useTheme();
  const navigate = useNavigate();

  useTitle(product?.title || 'Produkt');

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 94px)',
        maxWidth: '1500px',
        width: '80%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '92px',
        height: 'calc(100vh - 94px)',
        [theme.breakpoints.down('md')]: {
          mt: '120px',
        },
      }}
    >
      <ProductPresentation
        product={product}
        app={app}
        showCard={false}
        onDeploy={() => navigate(`/apps/${product.slug}`)}
      />
    </Box>
  );
}
